import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';

const propTypes = {
  employee: PropTypes.object.isRequired,
};

const renderTests = (employee) => {
  if (!employee.tests.length) {
    return <p>Employee has not performed any tests in this time period.</p>;
  }

  return (
    <Table bordered>
      <thead>
        <tr>
          <th>Date</th>
          <th>Client</th>
          <th>Radon Level (pCi/L)</th>
          <th>Working Level (WL)</th>
          <th>Hours of Exposure (HR)</th>
          <th>WLM</th>
        </tr>
      </thead>
      <tbody>
        {employee.tests.map((test, index) =>
          (
            <tr key={index}>
              <td>{test.exposed_at}</td>
              <td>{test.client_name}</td>
              <td>{test.result}</td>
              <td>{test.wl}</td>
              <td>{test.hr}</td>
              <td>{test.wlm}</td>
            </tr>
          ),
        )}
        <tr>
          <td colSpan="5"><b>Total</b></td>
          <td>{employee.total_wlm}</td>
        </tr>
      </tbody>
    </Table>
  );
};

const EmployeeExposureItem = ({ employee }) => (
  <li className="EmployeeExposureItem">
    <h5 className="EmployeeExposureItem__title">{employee.full_name}</h5>
    {renderTests(employee)}
  </li>
);

EmployeeExposureItem.propTypes = propTypes;

export default EmployeeExposureItem;



// WEBPACK FOOTER //
// ./src/features/reports/employee-exposure/EmployeeExposureItem.js